

export const formatNumberToUSDWithNegativeValues = (num?: number) => {
  if (typeof num === 'number' && !isNaN(num)) {
    let formattedNum = num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formattedNum;
  } else { // input was not a number. invalid input. return 0.
    return 0;
  }
}


export const eighteenYearsAgo = (): Date => {
  const today = new Date();
  return new Date(today.setMonth(today.getMonth() - 12 * 18));
}
